import { render, staticRenderFns } from "./SignatureCoRequester.vue?vue&type=template&id=5bb62414&scoped=true&"
import script from "./SignatureCoRequester.vue?vue&type=script&lang=js&"
export * from "./SignatureCoRequester.vue?vue&type=script&lang=js&"
import style0 from "./SignatureCoRequester.vue?vue&type=style&index=0&id=5bb62414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb62414",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout,VSnackbar})
